import { useQuery } from 'react-query'
import { message } from 'antd'
import { getSupportInfo } from 'utils/requests'
// helpers
import get from 'lodash/get'
import { useEffect } from 'react'

const useFetchData = (states, actions) => {
  const handlerRequest = useQuery<any>({
    queryKey: 'support-tickets-data',
    queryFn: () =>
      getSupportInfo({
        filterSelected: states.filterSelected,
        type: states.typeSelected,
        page: states.page,
        search: states.searchInput,
        limit: 9
      }),
    initialData: [],
    select: rawData => {
      const data = get(rawData, 'data', [])
      const paginationInfo = get(rawData, 'paginationInfo', undefined)

      return {
        paginationInfo,
        data: data.map(({ id, ...ticket }) => ({
          id,
          ...ticket,
          key: `support-ticket-${id}`
        }))
      }
    },
    onSuccess: () => {
      actions.setDirtyBit(false)
    },
    onError: () => {
      actions.setDirtyBit(false)
      message.error({
        type: 'error',
        content: 'Algo ha salido mal'
      })
    }
  })

  useEffect(() => {
    states.dirtyBit && handlerRequest.refetch()
  }, [states.dirtyBit])

  return handlerRequest
}

export default useFetchData
